import { format as formatFunction } from 'date-fns';
import { az, ru } from 'date-fns/locale';
import i18n from 'i18next';

import { TimeFormat } from '@/constants/timeFormat';

const getDateLabel = (withTime, time, label, t) =>
  withTime ? `${t(label)}, ${time}` : t(label);

const isSameDay = (date1, date2) =>
  date1.getDate() === date2.getDate() &&
  date1.getMonth() === date2.getMonth() &&
  date1.getFullYear() === date2.getFullYear();

const isYesterday = (date1, date2) => {
  const yesterday = new Date(date1);
  yesterday.setDate(yesterday.getDate() - 1);
  return isSameDay(yesterday, date2);
};

export const getMessageTime = (timetoken, t, withTime = false) => {
  const today = new Date();
  const messageDate = new Date(timetoken);

  const time = formatFunction(timetoken, TimeFormat.time);

  switch (true) {
    case isSameDay(today, messageDate):
      return getDateLabel(withTime, time, 'today', t);
    case isYesterday(today, messageDate):
      return getDateLabel(withTime, time, 'yesterday', t);
    default:
      return formatFunction(timetoken, TimeFormat.longMonthWithYear, {
        locale: i18n.language === 'az' ? az : ru
      });
  }
};
